import React from "react";
import Typography from "@material-ui/core/Typography";
const FinanceReports = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Finance Reports
      </Typography>
      <Typography paragraph variant="h5">
        Explore dashboard and various reports of Finance module
      </Typography>
      <Typography paragraph variant="body1">
        Finance Reports is one of the features under the Finance module to
        display various reports regarding the Finance business process. It is
        used to analyze information, determine conclusions, and offer
        recommendations to solve problems.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the tabs indicating
        the various report types. The various reports under the Finance module
        are listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Finance Dashboard</b>
        <br />
        This is the main dashboard of the Finance module. There is a lot of
        high-level information shown as a widget to give you the best insight
        regarding what happens in the Finance business process. This best
        analytic information will help you a lot to make business decisions.
        Below are the available widgets inside this dashboard:
        <ul>
          <li>Quick Ratio Widget</li>
          <li>Current Ratio Widget</li>
          <li>Debt Equity Ratio Widget</li>
          <li>Equity Ratio Widget</li>
          <li>Net Profit Margin Widget</li>
          <li>Gross Profit Margin Widget</li>
          <li>Cash on Hand Widget</li>
          <li>Inventory Widget</li>
          <li>Accounts Receivable Widget</li>
          <li>Accounts Payable Widget</li>
          <li>Profit & Loss Summary Widget</li>
          <li>A/R Invoice Status Widget</li>
          <li>A/P Invoice Status Widget</li>
          <li>A/R Invoice Aging Summary Widget</li>
          <li>A/P Invoice Aging Summary Widget</li>
          <li>Net Profit Widget</li>
          <li>Revenue Widget</li>
          <li>Cost of Goods Sold Widget</li>
          <li>Expenses Widget</li>
          <li>Cash Flow Widget</li>
          <li>A/R vs A/P Turnover Ratio Widget</li>
          <li>Working Capital Widget</li>
          <li>Top 5 Revenues Widget</li>
          <li>Top 5 Expenses Widget</li>
        </ul>
      </Typography>
      <Typography paragraph variant="body1">
        <b>Balance Sheet</b>
        <br />
        This report tells you about the financial statement that reports a
        company's assets, liabilities, and shareholder equity. The balance sheet
        statement is one of the three core financial statements that are used to
        evaluate a business. It provides a snapshot of what a company owns and
        owes, as well as the amount invested by shareholders.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Profit Loss</b>
        <br />
        This report tells you about the financial statement that summarizes the
        revenues, costs, and expenses incurred during a specified period. The
        profit loss statement is one of three financial statements that every
        public company issues quarterly and annually, along with the balance
        sheet and the cash flow statement. It provides an in-depth look at a
        company’s overall financial performance.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Cash Flow</b>
        <br />
        This report tells you about the financial statement that summarizes the
        amount of cash and cash equivalents entering and leaving a company. The
        cash flow statement is one of three financial statements that complement
        the balance sheet and the profit loss statement. It provides a
        measurement of how well a company manages its cash position, meaning how
        well the company generates cash to pay its debt obligations and fund its
        operating expenses.
      </Typography>
      <Typography paragraph variant="body1">
        <b>A/R Aging</b>
        <br />
        This report tells you about the evaluation of outstanding customer
        invoices as Accounts Receivable. It is categorized by date ranges,
        typically 30 days, to determine how long a bill has gone unpaid.
      </Typography>
      <Typography paragraph variant="body1">
        <b>A/P Aging</b>
        <br />
        This report tells you about the evaluation of outstanding vendor
        invoices as Accounts Payable. It is categorized by date ranges,
        typically 30 days, to determine how long a bill has gone unpaid.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Account Balance</b>
        <br />
        This report tells you about the current value of a financial account,
        such as a checking, savings, or investment account. An account balance
        is also evident on billing statements for credit cards, utilities, and
        loans.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Sales Tax</b>
        <br />
        This report tells you about the consumption tax on the sale of goods and
        services. A conventional sales tax is levied at the sales order or point
        of sale, collected by the seller, and passed on to the government.
      </Typography>
    </React.Fragment>
  );
};

export default FinanceReports;
